import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FaEllipsisH } from "react-icons/fa";
import * as localService from "../../services/localService";
import InformationModal from "../../components/informationModal";
import Pagination from "../../components/Pagination";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../shadcn/ui/table";
import { Badge } from "../../shadcn/ui/badge";
import { formatDateTime } from "../../utils/dateUtils";

import "react-bootstrap-tagsinput/dist/index.css";
import apiService from "../../services/apiService";
import { Tabs, TabsList, TabsTrigger } from "../../shadcn/ui/tabs";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../shadcn/ui/dialog";
import { Button } from "../../shadcn/ui/button";
import { Input } from "../../shadcn/ui/input";
import { Label } from "../../shadcn/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../shadcn/ui/select";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../shadcn/ui/dropdown-menu";
import { PhoneInput } from "../../components/ui/phone-input";
import logger from "../../utils/logger";
import geminiService from "../../services/geminiService";
import { apiV2Service, v2PublicApiService } from "../../services/apiV2Service";
import { showApiMessage } from "../../utils/messageHandler";
import { spaceManagementService } from "../../services/host-apiServices/spaceManagementService";
import toastUtils from "../../utils/toast";
import { User, Search, X, MoreHorizontal, Trash2, Edit, Mail, Loader2 } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../shadcn/ui/tooltip";
import { getWebOriginForFlavor, getFlavorForRole } from "../../utils/deepLink";

const initialInviteUserState = {
  username: "",
  firstName: "",
  lastName: "",
  emailAddress: "",
  msisdn: "",
  role: "",
};

const UserManagement = () => {
  const [organizationRoles, setOrganizationRoles] = useState([]);
  const [organizationRolesLoading, setOrganizationRolesLoading] = useState(false);

  const [_verifiedSearchValue, setVerifiedSearchValue] = useState("");
  const [_unVerifiedSearchValue, setUnverifiedSearchValue] = useState("");
  const [_verifiedCurrentPage, setVerifiedCurrentPage] = useState(1);
  const [_unverifiedCurrentPage, setUnverifiedCurrentPage] = useState(1);
  const [_verifiedTotalPageSize, setVerifiedTotalPageSize] = useState(0);
  const [_verifiedItemsPerPage, setVerifiedItemsPerPage] = useState(10);
  const [unverifiedTotalPageSize, setUnverifiedTotalPageSize] = useState(0);
  const [unverifiedItemsPerPage, setUnverifiedItemsPerPage] = useState(10);
  const [isBookingLoading, setIsBookingLoading] = useState(false);
  const [isProcessingFile, setIsProcessingFile] = useState(false);

  const [isRoleNotSelected, setIsRoleNotSelected] = useState(false);
  const [isBundleNotSelected, setIsBundleNotSelected] = useState(false);
  const [isBulkBundleNotSelected, setIsBulkBundleNotSelected] = useState(false);
  const [noAddedEmail, setNoAddedEmail] = useState(false);
  const [isBulkRoleNotSelected, setIsBulkRoleNotSelected] = useState(false);
  const [isInviteFileNotChosen, setIsInviteFileNotChosen] = useState(false);
  const [bundles, setBundles] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(0);

  // Functions
  const deleteUser = id => {
    setDeleteShow(true);
    setUserId(id);
  };
  const disableUser = id => {
    setDisableModal(true);
    setUserId(id);
  };

  const enableUser = id => {
    setEnableModal(true);
    setUserId(id);
  };

  const resetUserPassword = email => {
    setResetPasswordModal(true);

    logger.log("about to set email of selected user. email: [ " + email + " ]");
    setEmailOfSelectedUser(email);
  };

  const [currentSelectedUser, setCurrentSelectedUser] = useState({});
  const [currentUserRole, setCurrentUserRole] = useState("");
  const [subAccountRoles, setSubAccountRoles] = useState([]);
  const [organizationTypes, setOrganizationTypes] = useState([]);
  const [bulkSubAccountRoles, setBulkSubAccountRoles] = useState([]);
  // const [currentSelectedName, setCurrentSelectedName] = useState("Nana Kweku");
  // const [currentSelectedEmail, setCurrentSelectedEmail] = useState("mr.adumatta@gmail.com");
  // const [currentSelectedMobile, setCurrentSelectedMobile] = useState("0545977791");

  const defaultAvatar =
    "https://storage.googleapis.com/maestro-8beff.appspot.com/user-543-_1626834155761_69ec79f5_1b40_4716_9958_1a6f557f6581.jpeg";

  // Style definitions for status badges
  const getStatusBadgeClass = status => {
    if (status.toLowerCase() === "admin") {
      return "bg-red-100 text-red-600 font-semibold px-4 py-1 rounded";
    } else if (status.toLowerCase() === "approver") {
      return "bg-amber-100 text-amber-600 font-semibold px-4 py-1 rounded";
    } else if (status.toLowerCase() === "employee") {
      return "bg-green-100 text-green-700 font-semibold px-4 py-1 rounded";
    }
    return "bg-gray-100 text-gray-600 font-semibold px-4 py-1 rounded";
  };

  const convertRole = role => {
    switch (role) {
      case "ROLE_SUBSCRIBER_APPROVER":
        return "APPROVER";
      case "ROLE_SUBSCRIBER_INDIVIDUAL":
        return "REGULAR";
      case "ROLE_CONTENT_PUBLISHER":
        return "CONTENT PUBLISHER";
      case "ROLE_HOST_OPERATIONS":
        return "OPERATIONS ACCOUNT";
      case "ROLE_SUBSCRIBER_OWNER":
        return "CORPORATE ADMIN";
      case "ROLE_HOST":
        return "HOST";
      case "ROLE_EMPLOYEE":
        return "EMPLOYEE";
      case "ROLE_APPROVER_EMPLOYEE":
        return "MEETING ADMIN";
      default:
        return "N/A";
    }
  };

  // Configure verified users table columns for ResponsiveTable
  const verifiedColumns = [
    {
      key: "name",
      header: "Name",
      render: user => (
        <div className="flex items-center">
          <img src={user.avatar || defaultAvatar} alt={user.name} className="mr-3 w-10 h-10 rounded-full" />
          <span className="font-medium">{user.name}</span>
        </div>
      ),
      mobileLabel: "Name",
      mobileRender: user => (
        <div className="flex items-center">
          <img src={user.avatar || defaultAvatar} alt={user.name} className="mr-3 w-10 h-10 rounded-full" />
          <span className="font-medium">{user.name}</span>
        </div>
      ),
    },
    {
      key: "email",
      header: "Email",
      render: user => user.email,
      mobileLabel: "Email",
    },
    {
      key: "status",
      header: "Status",
      render: user => (
        <span className={user.status === "Active" ? "text-blue-600 font-semibold" : "text-gray-500 font-semibold"}>
          {user.status}
        </span>
      ),
      mobileLabel: "Status",
      mobileRender: user => (
        <span className={user.status === "Active" ? "text-blue-600 font-semibold" : "text-gray-500 font-semibold"}>
          {user.status}
        </span>
      ),
    },
    {
      key: "role",
      header: "Role",
      render: user => <span className={getStatusBadgeClass(user.role)}>{user.role}</span>,
      mobileLabel: "Role",
      mobileRender: user => <span className={getStatusBadgeClass(user.role)}>{user.role}</span>,
    },
    {
      key: "actions",
      header: "Actions",
      render: user => (
        <div className="flex relative items-center">
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={e => {
              e.stopPropagation();
              // Toggle dropdown here
            }}
          >
            <FaEllipsisH />
          </button>
          {/* Dropdown would be implemented here */}
        </div>
      ),
      mobileRender: user => (
        <div className="flex mt-2 space-x-2">
          <button
            className="px-3 py-1 text-sm text-blue-600 bg-blue-50 rounded"
            onClick={e => {
              e.stopPropagation();
              handleEditShow(user.originalData);
            }}
          >
            Edit
          </button>
          <button
            className={
              user.status === "Active"
                ? "bg-orange-50 text-orange-600 px-3 py-1 rounded text-sm"
                : "bg-green-50 text-green-600 px-3 py-1 rounded text-sm"
            }
            onClick={e => {
              e.stopPropagation();
              const status = user.status;
              if (status.toLowerCase().indexOf("inactive") > -1) {
                enableUser(user.originalData.id);
              } else {
                disableUser(user.originalData.id);
              }
            }}
          >
            {user.status === "Active" ? "Disable" : "Enable"}
          </button>
          <button
            className="px-3 py-1 text-sm text-gray-600 bg-gray-50 rounded"
            onClick={e => {
              e.stopPropagation();
              resetUserPassword(user.email);
            }}
          >
            Reset
          </button>
        </div>
      ),
    },
  ];

  // Add the employee plan column conditionally
  if (currentUserRole && currentUserRole === "ROLE_SUBSCRIBER_OWNER") {
    verifiedColumns.splice(4, 0, {
      key: "packagePlan",
      header: "Employee Plan",
      render: user => user.packagePlan || "N/A",
      mobileLabel: "Employee Plan",
    });
  }

  // Transform the verified users for the ResponsiveTable
  const transformVerifiedUsers = () => {
    return verifiedUsers.map(user => ({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.username,
      status: convertFromVerifiedStatus(user),
      role: convertRole(user.role),
      packagePlan: user.packagePlan,
      avatar: user.avatar || defaultAvatar,
      originalData: user,
    }));
  };

  const [userId, setUserId] = useState(0);
  const [emailOfSelectedUser, setEmailOfSelectedUser] = useState("");

  const [unVerifiedUsers, setUnVerifiedUsers] = useState([]);
  const [verifiedUsers, setVerifiedUsers] = useState([]);
  const [pendingDeletions, setPendingDeletions] = useState([]);
  const [_pendingDeletionsCurrentPage, setPendingDeletionsCurrentPage] = useState(1);
  const [_pendingDeletionsTotalPageSize, setPendingDeletionsTotalPageSize] = useState(0);
  const [_pendingDeletionsSearchValue, setPendingDeletionsSearchValue] = useState("");

  //set state to toggle invite user
  const [show, setShow] = useState(false);

  //set state to toggle edit user
  const [editShow, setEditShow] = useState(false);

  //set state to toggle delete user
  const [deleteshow, setDeleteShow] = useState(false);

  //set state to toggle confirm delete user
  const [_confirmDelete, setConfirmDelete] = useState(false);

  //set state to toggle confirm adding user
  const [_confirmUserAddition, setConfirmUserAddition] = useState(false);

  const [_openProfileUpdate, setOpenProfileUpdate] = useState(false);
  const [_profileUpdated, setProfileUpdated] = useState(false);
  // const [loaded, setLoaded] = useState(false);

  const [role, setRole] = useState("");
  const [bulkRole, setBulkRole] = useState("");
  const [bulkPackagePlan, setBulkPackagePlan] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedBundle, setSelectedBundle] = useState("");

  const [state, setState] = useState([]);

  useEffect(() => {
    logger.log("state holding email of invitees:", state);
  }, [state]);

  // Debug useEffect to monitor subAccountRoles changes
  useEffect(() => {
    logger.log("🔍 DEBUG - subAccountRoles changed:", subAccountRoles);
    logger.log("🔍 DEBUG - subAccountRoles length:", subAccountRoles.length);
  }, [subAccountRoles]);

  // Debug useEffect to monitor organizationTypes changes
  useEffect(() => {
    logger.log("🔍 DEBUG - organizationTypes changed:", organizationTypes);
    logger.log("🔍 DEBUG - organizationTypes length:", organizationTypes.length);
  }, [organizationTypes]);

  const [_UnableToConfirmUserAddition, setUnableToConfirmUserAddition] = useState(false);

  useEffect(() => {
    const currentUser = localService.getUser();
    const currentUserRole = currentUser?.role;
    const id = currentUser ? currentUser.id : 0;

    logger.log("current user role:", currentUserRole);

    setCurrentUserRole(currentUserRole);
    setCurrentUserId(id);

    // Fetch organization types and roles from API
    fetchOrganizationData();
  }, []);

  const fetchOrganizationData = async () => {
    try {
      logger.log("Fetching organization types...");

      // Get organization types from public API
      const orgTypesResponse = await v2PublicApiService.getOrganizationTypes();
      logger.log("Organization types response:", orgTypesResponse);

      if (orgTypesResponse.status === 200) {
        const orgTypes = orgTypesResponse.data?.data || [];

        logger.log("🔍 DEBUG - API Response - Organization types:", orgTypes);
        logger.log("🔍 DEBUG - API Response - Org types length:", orgTypes.length);

        // Store organization types
        setOrganizationTypes(orgTypes);
        logger.log("🔍 DEBUG - Set organizationTypes to:", orgTypes);
      } else {
        logger.log("🔍 DEBUG - API call failed:", {
          orgTypesStatus: orgTypesResponse.status,
        });
      }

      // Fetch organization roles directly from API
      setOrganizationRolesLoading(true);
      try {
        const rolesResponse = await apiV2Service.getOrganizationRoles({
          active: true,
          limit: 100,
          orderBy: "name:asc",
        });

        if (rolesResponse && rolesResponse.data) {
          // Get current user's organization type ID
          const currentUser = localService.getUser();
          const userOrgTypeId = currentUser?.organization?.typeId;

          // Filter roles by matching organizationTypeId
          const allRoles = rolesResponse.data;
          const filteredRoles = userOrgTypeId
            ? allRoles.filter(role => role.organizationTypeId === userOrgTypeId)
            : allRoles;

          logger.log(
            `✅ Loaded ${allRoles.length} organization roles, filtered to ${filteredRoles.length} for typeId ${userOrgTypeId}`
          );
          setOrganizationRoles(filteredRoles);
        }
      } catch (error) {
        logger.error("Error fetching organization roles:", error);
        setOrganizationRoles([]);
      } finally {
        setOrganizationRolesLoading(false);
      }
    } catch (error) {
      logger.error("Error fetching organization data:", error);
    }
  };

  // Organization types and roles are now fetched from API

  // Add orgTypeId state for invite modal - auto-determined from current user
  const [_inviteOrgTypeId, setInviteOrgTypeId] = useState(null);
  const [_bulkInviteOrgTypeId, setBulkInviteOrgTypeId] = useState(null);

  // Functions to toggle Invite User Modal
  const handleClose = () => setShow(false);
  const handleShow = () => {
    const currentUser = localService.getUser();
    const userOrgTypeId = currentUser?.organization?.typeId || currentUser?.organizationTypeId || null;
    const userRole = currentUser?.role;

    logger.log("🔍 DEBUG - Opening invite modal");
    logger.log("🔍 DEBUG - User org type ID:", userOrgTypeId);
    logger.log("🔍 DEBUG - Available organization types:", organizationTypes);
    logger.log("🔍 DEBUG - Current subAccountRoles:", subAccountRoles);
    logger.log("🔍 DEBUG - subAccountRoles length:", subAccountRoles.length);

    setInviteOrgTypeId(userOrgTypeId);
    setBulkInviteOrgTypeId(userOrgTypeId);

    // The roles should already be set from fetchOrganizationData
    // Just open the modal
    setShow(true);
  };

  // Functions to toggle Delete Modal
  const handleDeleteClose = () => {
    setDeleteShow(false);
    setUserToDelete(null);
  };
  const handleDeleteShow = id => {
    // logger.log(id)
    logger.log(id);
    setDeleteShow(true);
    deleteUser(id);
  };

  // Functions to toggle Edit User Modal
  const handleEditClose = () => setEditShow(false);
  const handleEditShow = user => {
    logger.log("📝 Opening edit dialog for user:", user);
    logger.log("📋 Available organization roles:", organizationRoles);
    logger.log("📊 Organization roles count:", organizationRoles.length);
    logger.log("🔍 User's current organizationRoleId:", user.organizationRoleId);

    // set current user
    setCurrentSelectedUser(user);

    // Populate edit form with current user data
    setEditFormData({
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      emailAddress: user.emailAddress || "",
      msisdn: user.msisdn || "",
      organizationRoleId: user.organizationRoleId || "",
      status: user.status || "ACTIVE",
      imageUrl: user.imageUrl || "",
    });

    logger.log("✅ Edit form populated with data:", {
      firstName: user.firstName,
      lastName: user.lastName,
      emailAddress: user.emailAddress,
      msisdn: user.msisdn,
      organizationRoleId: user.organizationRoleId,
      status: user.status,
    });

    setEditShow(true);
  };

  // Functions to toggle confirm user deletion Modal
  const confirmDeleteClose = () => setConfirmDelete(false);
  const confirmDeleteOpen = () => {
    confirmDeleteUser();
    setDeleteShow(false);
  };

  // Functions to toggle confirm adding user
  const confirmUserClose = () => setConfirmUserAddition(false);
  const confirmUserOpen = () => {
    setConfirmUserAddition(true);
    setEditShow(!editShow);
  };

  const handleCloseProfileUpdate = () => setOpenProfileUpdate(false);

  const [editFormData, setEditFormData] = useState({
    firstName: "",
    lastName: "",
    emailAddress: "",
    msisdn: "",
    organizationRoleId: "",
    status: "",
    imageUrl: "",
  });

  const handleEditFormChange = (field, value) => {
    setEditFormData(prev => ({ ...prev, [field]: value }));
  };

  const updateUserProfile = async () => {
    if (!currentSelectedUser || !currentSelectedUser.id) {
      showApiMessage(
        {
          response: {
            status: 400,
            data: { message: "No user selected for update" },
          },
        },
        "update user"
      );
      return;
    }

    try {
      const oldStatus = currentSelectedUser.status;
      const newStatus = editFormData.status;

      // Check if user is being activated from INACTIVE or DISABLED status
      const isActivatingInactiveUser = oldStatus === "INACTIVE" && newStatus === "ACTIVE";
      const isActivatingDisabledUser = oldStatus === "DISABLED" && newStatus === "ACTIVE";

      if (isActivatingInactiveUser) {
        // For INACTIVE users (pending confirmation), resend confirmation email
        logger.log("Resending account confirmation for INACTIVE user:", currentSelectedUser.username);
        const role = organizationRoles.find(r => r.id === currentSelectedUser.organizationRoleId);
        const flavor = getFlavorForRole(role?.code || currentSelectedUser.organizationRole?.code);
        const origin = getWebOriginForFlavor(flavor);
        const confirmationUrl = `${origin}/?action=confirm_account`;
        await apiV2Service.resendAccountConfirmation({
          username: currentSelectedUser.username,
          confirmationUrl,
        });
        showApiMessage(
          { status: 202, data: { message: "Account confirmation email resent successfully" } },
          "resend confirmation"
        );
        setEditShow(false);
        fetchUsers(userStatus, pagination.page, pagination.limit);
        return;
      } else if (isActivatingDisabledUser) {
        // For DISABLED users, use reactivation endpoint
        logger.log("Reactivating DISABLED user:", currentSelectedUser.id);
        const role = organizationRoles.find(r => r.id === currentSelectedUser.organizationRoleId);
        const flavor = getFlavorForRole(role?.code || currentSelectedUser.organizationRole?.code);
        const origin = getWebOriginForFlavor(flavor);
        const confirmationUrl = `${origin}/?action=confirm_account`;
        const response = await apiV2Service.reactivateUser(currentSelectedUser.id, { confirmationUrl });
        showApiMessage(response, "reactivate user");
        setEditShow(false);
        fetchUsers(userStatus, pagination.page, pagination.limit);
        return;
      }

      // For all other updates, use regular PATCH
      const payload = {
        firstName: editFormData.firstName,
        lastName: editFormData.lastName,
        emailAddress: editFormData.emailAddress,
        msisdn: editFormData.msisdn,
        ...(editFormData.imageUrl ? { imageUrl: editFormData.imageUrl } : {}),
      };

      // Only include status if it's changed and it's not INACTIVE
      // INACTIVE users are handled via reactivation/confirmation email endpoints
      if (newStatus !== oldStatus && newStatus !== "INACTIVE") {
        payload.status = newStatus;
      }

      // Only include organizationRoleId if it's changed
      if (
        editFormData.organizationRoleId &&
        editFormData.organizationRoleId !== currentSelectedUser.organizationRoleId
      ) {
        payload.organizationRoleId = editFormData.organizationRoleId;
      }

      // Remove empty fields (but keep organizationRoleId and status if they were added)
      Object.keys(payload).forEach(key => {
        if (!payload[key] && key !== "organizationRoleId" && key !== "status") delete payload[key];
      });

      logger.log("Updating user with payload:", payload);

      const response = await apiV2Service.updateUser(currentSelectedUser.id, payload);

      showApiMessage(response, "update user");
      setEditShow(false);

      // Refresh the user list
      fetchUsers(userStatus, pagination.page, pagination.limit);
    } catch (err) {
      logger.error("Error updating user:", err);
      showApiMessage(err, "update user");
    }
  };

  // Functions to toggle disable user
  const disableUserClose = () => setConfirmUserAddition(false);
  const confirmDisableUser = async () => {
    setDisableModal(false);

    try {
      const response = await apiV2Service.updateUser(userId, {
        status: "DISABLED",
      });

      showApiMessage(response, "disable user");
      setConfirmDisableModal(true);

      // Refresh the user list
      fetchUsers(userStatus, pagination.page, pagination.limit);
    } catch (err) {
      logger.error("Error disabling user:", err);
      showApiMessage(err, "disable user");
    }
  };

  const [resendingUserId, setResendingUserId] = useState(null);

  const handleResendConfirmation = async (user) => {
    if (!user || !user.username) {
      toastUtils.error("User information is missing");
      return;
    }

    setResendingUserId(user.id);
    try {
      logger.log("Resending account confirmation for user:", user.username);
      const role = organizationRoles.find(r => r.id === user.organizationRoleId);
      const flavor = getFlavorForRole(role?.code || user.organizationRole?.code);
      const origin = getWebOriginForFlavor(flavor);
      const confirmationUrl = `${origin}/?action=confirm_account`;

      const response = await apiV2Service.resendAccountConfirmation({
        username: user.username,
        confirmationUrl,
      });

      showApiMessage(
        response || { status: 202, data: { message: "Account confirmation email resent successfully" } },
        "resend confirmation"
      );
    } catch (err) {
      logger.error("Error resending confirmation email:", err);
      showApiMessage(err, "resend confirmation");
    } finally {
      setResendingUserId(null);
    }
  };

  const [enableModal, setEnableModal] = useState(false);
  const [_confirmEnableModal, setConfirmEnableModal] = useState(false);
  const enableUserClose = () => setConfirmUserAddition(false);
  const confirmEnableUser = async () => {
    setEnableModal(false);

    try {
      // Find the user to get their current status
      const user = users.find(u => u.id === userId);
      const currentStatus = user?.status;

      logger.log("Enabling user:", { userId, currentStatus });

      if (currentStatus === "INACTIVE") {
        // For INACTIVE users (pending confirmation), resend confirmation email
        logger.log("Resending account confirmation for INACTIVE user:", user?.username);
        const role = organizationRoles.find(r => r.id === user?.organizationRoleId);
        const flavor = getFlavorForRole(role?.code || user?.organizationRole?.code);
        const origin = getWebOriginForFlavor(flavor);
        const confirmationUrl = `${origin}/?action=confirm_account`;
        await apiV2Service.resendAccountConfirmation({
          username: user?.username,
          confirmationUrl,
        });
        showApiMessage(
          { status: 202, data: { message: "Account confirmation email resent successfully" } },
          "resend confirmation"
        );
      } else if (currentStatus === "DISABLED") {
        // For DISABLED users, use reactivation endpoint
        logger.log("Reactivating DISABLED user:", userId);
        const role = organizationRoles.find(r => r.id === user?.organizationRoleId);
        const flavor = getFlavorForRole(role?.code || user?.organizationRole?.code);
        const origin = getWebOriginForFlavor(flavor);
        const confirmationUrl = `${origin}/?action=confirm_account`;
        const response = await apiV2Service.reactivateUser(userId.toString(), { confirmationUrl });
        showApiMessage(response, "reactivate user");
      } else {
        // For other status changes, use regular PATCH
        const response = await apiV2Service.updateUser(userId, {
          status: "ACTIVE",
        });
        showApiMessage(response, "enable user");
      }

      setConfirmEnableModal(true);

      // Refresh the user list
      fetchUsers(userStatus, pagination.page, pagination.limit);
    } catch (err) {
      logger.log("error here:", err.response?.data);
      showApiMessage(err, "enable user");
    }
  };

  const [disableModal, setDisableModal] = useState(false);
  const [_confirmDisableModal, setConfirmDisableModal] = useState(false);

  const handleDisableUser = () => {
    logger.log("Here");
    setDisableModal(true);
  };

  const _loaded = true;

  // Reset Password

  const [_resetPasswordModal, setResetPasswordModal] = useState(false);
  const [_confirmResetPasswordModal, setConfirmResetPasswordModal] = useState(false);

  const closeResetPasswordModal = () => {
    setResetPasswordModal(false);
  };

  const confirmResetPassword = () => {
    const emailOfUser = emailOfSelectedUser || "";
    apiService
      .resetUserPassword(emailOfUser)
      .then(res => {
        // email sent successfully
        setResetPasswordModal(false);
        setConfirmResetPasswordModal(true);
        showApiMessage(res, "reset password");
      })
      .catch(err => {
        logger.log(err.response?.data);
        showApiMessage(err, "reset password");
      });
  };

  useEffect(() => {
    if (role) {
      setIsRoleNotSelected(false);
    }
    if (bulkRole) {
      setIsBulkRoleNotSelected(false);
    }
    if (bulkPackagePlan) {
      setIsBulkBundleNotSelected(false);
    }
    if (selectedFile) {
      setIsInviteFileNotChosen(false);
    }
  }, [role, bulkRole, selectedFile, bulkPackagePlan]);

  useEffect(() => {
    if (state.length > 0) {
      setNoAddedEmail(false);
    }
  }, [state]);

  const areFieldsOkay = () => {
    const requiredFields = [role];
    // is any of the fields empty
    const anyEmpty = requiredFields.some(field => !field) || state.length === 0;
    if (anyEmpty) {
      if (!role) {
        setIsRoleNotSelected(true);
      }
      if (state.length === 0) {
        setNoAddedEmail(true);
      }
      return false;
    } else {
      return true;
    }
  };

  const areFieldsOkayForBulk = () => {
    const requiredFields = [selectedFile, bulkRole];
    // is any of the fields empty
    const anyEmpty = requiredFields.some(field => !field);
    if (anyEmpty) {
      if (!bulkRole) {
        setIsBulkRoleNotSelected(true);
      }

      if (!bulkPackagePlan) {
        setIsBulkBundleNotSelected(true);
      }

      if (!selectedFile) {
        setIsInviteFileNotChosen(true);
      }
      return false;
    } else {
      return true;
    }
  };

  let history = useHistory();

  const [inviteUserForm, setInviteUserForm] = useState(initialInviteUserState);

  const handleInviteUserInputChange = e => {
    const { name, value } = e.target;
    setInviteUserForm(prev => ({ ...prev, [name]: value }));
  };

  const areInviteUserFieldsOkay = () => {
    const { username, firstName, lastName, emailAddress, role } = inviteUserForm;
    if (!username || !firstName || !lastName || !emailAddress || !role) {
      setIsRoleNotSelected(!role);
      toastUtils.error("Please fill all required fields.");
      return false;
    }

    if (username && username.trim() !== username) {
      toastUtils.error("Username cannot have leading or trailing spaces.");
      return false;
    }

    return true;
  };

  const inviteUser = async () => {
    if (!areInviteUserFieldsOkay()) return;

    const currentUser = localService.getUser();
    const organizationId = currentUser?.organizationId;
    const role = organizationRoles.find(r => r.id === inviteUserForm.role);
    const flavor = getFlavorForRole(role?.code);
    const origin = getWebOriginForFlavor(flavor);
    const confirmationUrl = origin + "/?action=confirm_account";
    // inviteUserForm.role now contains the role ID directly from Redux
    const roleId = inviteUserForm.role;

    if (!organizationId || !roleId) {
      toastUtils.error("Missing organization or role information.");
      return;
    }

    setIsBookingLoading(true);
    try {
      const payload = {
        organizationId,
        organizationRoleId: roleId,
        username: inviteUserForm.username,
        firstName: inviteUserForm.firstName,
        lastName: inviteUserForm.lastName,
        emailAddress: inviteUserForm.emailAddress,
        msisdn: inviteUserForm.msisdn || "",
        confirmationUrl,
      };
      const res = await apiV2Service.inviteUserV2(payload);
      showApiMessage(res, "invite user");
      setShow(false);
      setConfirmUserAddition(true);
      setInviteUserForm(initialInviteUserState);
    } catch (err) {
      logger.log(err);
      showApiMessage(err, "invite user");
    } finally {
      setIsBookingLoading(false);
    }
  };

  const handleFileChange = event => {
    setSelectedFile(event.target.files[0]);
  };

  const bulkUpload = async () => {
    logger.log("[bulkUpload] Initiating bulk upload...");
    logger.log("[bulkUpload] Selected File:", selectedFile);
    logger.log("[bulkUpload] Selected Role (bulkRole):", bulkRole);
    logger.log("[bulkUpload] Selected Bundle Plan (bulkPackagePlan):", bulkPackagePlan);

    if (!areFieldsOkayForBulk()) {
      logger.error("[bulkUpload] Initial field validation failed.");
      return;
    }

    const currentUser = localService.getUser();
    const organizationId = currentUser?.organizationId;
    const confirmationUrl = window.location.origin + "/?action=confirm_account";
    // bulkRole now contains the role ID directly from Redux
    const roleId = bulkRole;

    if (!organizationId || !roleId) {
      toastUtils.error("Missing organization or role information.");
      return;
    }

    setIsProcessingFile(true);
    try {
      const extractedEmails = await geminiService.preprocessFile(selectedFile);
      setIsProcessingFile(false);
      if (!extractedEmails || extractedEmails.length === 0) {
        toastUtils.error("No valid email addresses found in the file. Please check the file and try again.");
        return;
      }
      setIsBookingLoading(true);
      for (const email of extractedEmails) {
        const payload = {
          organizationId,
          organizationRoleId: roleId,
          username: email,
          firstName: "",
          lastName: "",
          emailAddress: email,
          msisdn: "",
          confirmationUrl,
        };
        const res = await apiV2Service.inviteUserV2(payload);
        showApiMessage(res, "invite user");
      }
      setShow(false);
      setConfirmUserAddition(true);
      // Optionally refresh user list here
    } catch (err) {
      setIsProcessingFile(false);
      setIsBookingLoading(false);
      logger.error("[bulkUpload] Error inviting users:", err);
      showApiMessage(err, "invite users");
    } finally {
      setIsBookingLoading(false);
    }
  };

  const handleRoleChange = e => {
    setRole(e.target.value);
  };

  const handleBulkRoleChange = e => {
    setBulkRole(e.target.value);
  };

  const handleBundleChange = e => {
    setSelectedBundle(e.target.value);
  };

  const handleBulkBundleChange = e => {
    setBulkPackagePlan(e.target.value);
  };
  // const deleteTask = async (id) =>{
  //     await fetch(`http://localhost:5000/tasks/${id}`,{
  //       method:'DELETE'
  //     })
  //     setTasks(tasks.filter((task) => task.id !== id))
  //     logger.log('deleted', id)
  //   }

  const deleteuser = id => {
    const user = localService.getUser();
    const ownerId = user ? user.id : 0;

    logger.log("user id is", id, "and owner id is", ownerId);

    apiService
      .deleteUser(id, ownerId)
      .then(res => {
        logger.log(res);
        showApiMessage(res, "delete user");
      })
      .catch(err => {
        logger.log(err);
        showApiMessage(err, "delete user");
      });
  };

  // useEffect(() => {
  //   const currentUser = localService.getUser();
  //   const ownerId = currentUser ? currentUser.id : 0;
  //   // const resourceUrl = `${Constants.BASE_URL}/users/api/v1/users/${ownerId}/sub-accounts`;

  //   // get unverified users
  //   apiService
  //     .getSubAccounts(ownerId, {
  //       sortBy: "createdDate",
  //       verified: false,
  //       page: 0,
  //       size: 10,
  //     })
  //     .then(res => {
  //       if (res.status === 200) {
  //         logger.log(res);
  //         const subAccounts = res.data.data || [];

  //         // const verifiedUsers = subAccounts.filter((s) => s.verified);
  //         setUnVerifiedUsers(subAccounts);

  //         setUnverifiedTotalPageSize(res.data.totalCount || 0);
  //         // setTotalPageSize(500);
  //         setUnverifiedItemsPerPage(res.data.pageSize || 10);

  //         // const unverifiedUsers = subAccounts.filter((s) => !s.verified);
  //         // setUnVerifiedUsers(unverifiedUsers);
  //       }
  //     })
  //     .catch(err => {
  //       logger.error("Error fetching unverified accounts:", err);
  //       setUnVerifiedUsers([]);
  //     });
  // }, []);

  const convertFromVerifiedStatus = user => {
    if (user.verified) {
      if (user.enabled) {
        return "Active";
      }
      return "Inactive";
    } else {
      return "Pending";
    }
  };

  const downloadBulkUploadSample = () => {
    // Define the CSV content directly
    const csvHeader = "email\n";
    const emails = ["edem.agbakpe+11111@gmail.com", "edem.agbakpe+22222@gmail.com", "edem.agbakpe+33333@gmail.com"];
    const csvContent = csvHeader + emails.join("\n");

    // Create a Blob from the CSV string
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Create a link element
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // Feature detection
      // Create a URL for the blob
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "bulk_upload_sample.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Clean up the object URL
      URL.revokeObjectURL(url);
    } else {
      // Handle browsers that don't support the download attribute (less common now)
      logger.error("Browser does not support automatic download.");
      // Optionally, display the CSV content or provide alternative instructions
    }
  };

  const [_showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);

  const confirmDeleteUser = () => {
    if (!userToDelete) return;

    const currentUser = localService.getUser();
    const ownerId = currentUser ? currentUser.id : 0;

    if (!ownerId) return;

    apiV2Service
      .deleteUser(userToDelete.id)
      .then(response => {
        if (response.status === 200 || response.status === 204) {
          showApiMessage(response, "delete user");
          setDeleteShow(false);
          setUserToDelete(null);
          // Refresh the user list
          fetchUsers(userStatus, pagination.page, pagination.limit);
        }
      })
      .catch(error => {
        logger.error("Error deleting user:", error);
        showApiMessage(error, "delete user");
      });
  };

  const [showPendingDeleteModal, setShowPendingDeleteModal] = useState(false);
  const [_pendingUserToDelete, setPendingUserToDelete] = useState(null);

  const handlePendingDeleteClose = () => {
    setShowPendingDeleteModal(false);
    setPendingUserToDelete(null);
  };

  // Additional code for unverified users transformation
  const _unverifiedColumns = [
    {
      key: "name",
      header: "Name",
      render: user => (
        <div className="flex items-center">
          <img src={user.avatar || defaultAvatar} alt={user.name} className="mr-3 w-10 h-10 rounded-full" />
          <span className="font-medium">{user.name}</span>
        </div>
      ),
      mobileLabel: "Name",
      mobileRender: user => (
        <div className="flex items-center">
          <img src={user.avatar || defaultAvatar} alt={user.name} className="mr-3 w-10 h-10 rounded-full" />
          <span className="font-medium">{user.name}</span>
        </div>
      ),
    },
    {
      key: "email",
      header: "Email",
      render: user => user.email,
      mobileLabel: "Email",
    },
    {
      key: "status",
      header: "Status",
      render: user => <span className="font-semibold text-gray-500">{user.status}</span>,
      mobileLabel: "Status",
      mobileRender: user => <span className="font-semibold text-gray-500">{user.status}</span>,
    },
    {
      key: "role",
      header: "Role",
      render: user => <span className={getStatusBadgeClass(user.role)}>{user.role}</span>,
      mobileLabel: "Role",
      mobileRender: user => <span className={getStatusBadgeClass(user.role)}>{user.role}</span>,
    },
    {
      key: "actions",
      header: "Actions",
      render: user => (
        <div className="flex relative items-center">
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={e => {
              e.stopPropagation();
              deleteUser(user.originalData.id);
            }}
          >
            <FaEllipsisH />
          </button>
        </div>
      ),
      mobileRender: user => (
        <button
          className="px-3 py-1 text-sm text-red-600 bg-red-50 rounded"
          onClick={e => {
            e.stopPropagation();
            deleteUser(user.originalData.id);
          }}
        >
          Delete
        </button>
      ),
    },
  ];

  // Transform the unverified users for the ResponsiveTable
  const _transformUnverifiedUsers = () => {
    return unVerifiedUsers.map(user => ({
      id: user.id,
      name: user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : "N/A",
      email: user.username,
      status: convertFromVerifiedStatus(user),
      role: convertRole(user.role),
      avatar: user.avatar || defaultAvatar,
      originalData: user,
    }));
  };

  // Pending deletions columns for ResponsiveTable
  const _pendingDeletionsColumns = [
    {
      key: "name",
      header: "Name",
      render: user => (
        <div className="flex items-center">
          <img src={user.avatar || defaultAvatar} alt={user.name} className="mr-3 w-10 h-10 rounded-full" />
          <span className="font-medium">{user.name}</span>
        </div>
      ),
      mobileLabel: "Name",
      mobileRender: user => (
        <div className="flex items-center">
          <img src={user.avatar || defaultAvatar} alt={user.name} className="mr-3 w-10 h-10 rounded-full" />
          <span className="font-medium">{user.name}</span>
        </div>
      ),
    },
    {
      key: "email",
      header: "Email",
      render: user => user.email,
      mobileLabel: "Email",
    },
    {
      key: "role",
      header: "Role",
      render: user => <span className={getStatusBadgeClass(user.role)}>{user.role}</span>,
      mobileLabel: "Role",
      mobileRender: user => <span className={getStatusBadgeClass(user.role)}>{user.role}</span>,
    },
    {
      key: "status",
      header: "Status",
      render: user => (
        <span className={user.status === "Active" ? "text-blue-600 font-semibold" : "text-gray-500 font-semibold"}>
          {user.status}
        </span>
      ),
      mobileLabel: "Status",
      mobileRender: user => (
        <span className={user.status === "Active" ? "text-blue-600 font-semibold" : "text-gray-500 font-semibold"}>
          {user.status}
        </span>
      ),
    },
    {
      key: "actions",
      header: "Actions",
      render: user => (
        <div className="flex relative items-center">
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={e => {
              e.stopPropagation();
              setPendingUserToDelete(user.originalData);
              setShowPendingDeleteModal(true);
            }}
          >
            <FaEllipsisH />
          </button>
        </div>
      ),
      mobileRender: user => (
        <button
          className="px-3 py-1 text-sm text-red-600 bg-red-50 rounded"
          onClick={e => {
            e.stopPropagation();
            setPendingUserToDelete(user.originalData);
            setShowPendingDeleteModal(true);
          }}
        >
          Delete
        </button>
      ),
    },
  ];

  // Transform the pending deletions for the ResponsiveTable
  const _transformPendingDeletions = () => {
    return pendingDeletions.map(user => ({
      id: user.id,
      name: `${user.firstName} ${user.lastName}`,
      email: user.username,
      status: convertFromVerifiedStatus(user),
      role: convertRole(user.role),
      avatar: user.avatar || defaultAvatar,
      originalData: user,
    }));
  };

  // Add status filter buttons/tabs
  const _statusOptions = [
    { label: "Active", value: "active" },
    { label: "Disabled", value: "disabled" },
    { label: "Inactive", value: "inactive" },
  ];

  const [userStatus, setUserStatus] = useState("active");
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    totalPages: 0,
    page: 1,
    limit: 20,
  });
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const fetchUsers = async (status = userStatus, page = pagination.page, limit = 20, search = searchValue) => {
    setLoadingUsers(true);
    try {
      let response;
      if (search) {
        response = await apiV2Service.searchUsers({
          q: search,
          status: status.toUpperCase(),
          page,
          limit,
        });
      } else {
        response = await apiV2Service.getUsersByStatus(status, page, limit);
      }

      const { data, pagination: pag } = response.data || response;
      setUsers(Array.isArray(data) ? data : []);
      setPagination(pag && typeof pag.limit === "number" ? pag : { totalCount: 0, totalPages: 0, page: 1, limit: 20 });
    } catch (error) {
      setUsers([]);
      setPagination({ totalCount: 0, totalPages: 0, page: 1, limit: 20 });
      showApiMessage(error, "load users");
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleSearch = e => {
    e.preventDefault();
    fetchUsers(userStatus, 1, pagination.limit, searchValue);
  };

  const clearSearch = () => {
    setSearchValue("");
    fetchUsers(userStatus, 1, pagination.limit, "");
  };

  useEffect(() => {
    fetchUsers(userStatus, 1, pagination && typeof pagination.limit === "number" ? pagination.limit : 20);
    // eslint-disable-next-line
  }, [userStatus]);

  const handleStatusChange = status => {
    setUserStatus(status);
    fetchUsers(status, 1, pagination && typeof pagination.limit === "number" ? pagination.limit : 20);
  };

  const handlePageChange = pageObj => {
    // Pagination component passes { selected: pageNumber } where pageNumber is 1-indexed
    // API also expects 1-indexed pages (page >= 1)
    const pageNumber = pageObj?.selected ?? pageObj;
    const apiPage = typeof pageNumber === "number" ? pageNumber : 1;
    fetchUsers(userStatus, apiPage, pagination.limit);
  };

  const _columns = [
    {
      key: "index",
      header: "#",
      render: (user, index) => (
        <span className="text-gray-500 font-medium">{(pagination.page - 1) * pagination.limit + index + 1}</span>
      ),
      mobileLabel: "No.",
    },
    {
      key: "username",
      header: "Username",
      render: user => (
        <div className="flex items-center">
          {user.imageUrl ? (
            <img src={user.imageUrl} alt={user.username} className="object-cover mr-2 w-8 h-8 rounded-full border" />
          ) : (
            <div className="mr-2 w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600">
              {user.username?.charAt(0)?.toUpperCase() || "U"}
            </div>
          )}
          <span className="font-medium">{user.username}</span>
        </div>
      ),
      mobileLabel: "Username",
      mobileRender: user => (
        <div className="flex items-center">
          {user.imageUrl ? (
            <img src={user.imageUrl} alt={user.username} className="object-cover mr-2 w-8 h-8 rounded-full border" />
          ) : (
            <div className="mr-2 w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600">
              {user.username?.charAt(0)?.toUpperCase() || "U"}
            </div>
          )}
          <span className="font-medium">{user.username}</span>
        </div>
      ),
    },
    {
      key: "email",
      header: "Email",
      render: user => user.emailAddress,
      mobileLabel: "Email",
    },
    {
      key: "role",
      header: "Role",
      render: user => user.organizationRole?.name || "",
      mobileLabel: "Role",
    },
    {
      key: "status",
      header: "Status",
      render: user => user.status,
      mobileLabel: "Status",
    },
    {
      key: "createdAt",
      header: "Created",
      render: user => new Date(user.createdAt).toLocaleDateString(),
      mobileLabel: "Created",
    },
    {
      key: "actions",
      header: "Actions",
      render: user => (
        <div className="flex relative items-center">
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={e => {
              e.stopPropagation();
              handleEditShow(user.originalData);
            }}
          >
            <FaEllipsisH />
          </button>
        </div>
      ),
      mobileRender: user => (
        <div className="flex flex-col gap-2 mt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={e => {
              e.stopPropagation();
              handleEditShow(user.originalData);
            }}
            className="w-full"
          >
            <Edit className="mr-2 h-4 w-4" />
            Edit User
          </Button>
          {user.id !== currentUserId && (
            <Button
              variant="outline"
              size="sm"
              onClick={e => {
                e.stopPropagation();
                setUserToDelete(user.originalData);
                setDeleteShow(true);
              }}
              className="w-full text-red-600 bg-red-50 hover:bg-red-100 hover:text-red-700 border-red-100"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Delete User
            </Button>
          )}
        </div>
      ),
    },
  ];

  const _transformUsers = () => {
    return Array.isArray(users)
      ? users.map(user => ({
          id: user.id,
          username: user.username,
          firstName: user.firstName,
          lastName: user.lastName,
          emailAddress: user.emailAddress,
          organizationRole: user.organizationRole,
          status: user.status,
          createdAt: user.createdAt,
          imageUrl: user.imageUrl,
          originalData: user,
        }))
      : [];
  };

  return (
    <div className="container px-4 py-6 mx-auto">
      {/* Header with Title and Add Button */}
      <div className="mb-6 flex flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <h1 className="text-3xl font-bold">User Management</h1>
          <Button onClick={handleShow}>Add New User</Button>
        </div>
        <div className="w-full pt-4 pb-3">
          <form onSubmit={handleSearch} className="relative w-full">
            <Input
              placeholder="Search users..."
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              className="pr-10 bg-white"
            />
            {searchValue ? (
              <button
                type="button"
                onClick={clearSearch}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <X className="h-4 w-4" />
              </button>
            ) : (
              <Search className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            )}
          </form>
        </div>
      </div>

      {/* Status Filter Tabs */}
      <div className="rounded-lg mb-6">
        <Tabs value={userStatus} onValueChange={handleStatusChange}>
          <TabsList>
            <TabsTrigger value="active">Active</TabsTrigger>
            <TabsTrigger value="inactive">Inactive</TabsTrigger>
            <TabsTrigger value="disabled">Disabled</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      {/* Table Content */}
      {loadingUsers ? (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="h-6 w-32 bg-gray-200 animate-pulse rounded" />
            <div className="h-6 w-20 bg-gray-200 animate-pulse rounded" />
          </div>
          <div className="overflow-hidden rounded-xl border border-gray-200">
            <div className="grid grid-cols-6 bg-gray-50">
              {["Username", "Email", "Role", "Status", "Created", "Actions"].map(label => (
                <div key={label} className="px-4 py-3">
                  <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                </div>
              ))}
            </div>
            <div className="divide-y divide-gray-100 bg-white">
              {Array.from({ length: 6 }).map((_, idx) => (
                <div key={`user-skel-${idx}`} className="grid grid-cols-6 px-4 py-3 items-center gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse" />
                    <div className="space-y-1">
                      <div className="h-4 w-24 bg-gray-200 animate-pulse rounded" />
                      <div className="h-3 w-16 bg-gray-200 animate-pulse rounded" />
                    </div>
                  </div>
                  <div className="h-4 w-36 bg-gray-200 animate-pulse rounded" />
                  <div className="h-6 w-20 bg-gray-200 animate-pulse rounded-full" />
                  <div className="h-6 w-16 bg-gray-200 animate-pulse rounded-full" />
                  <div className="space-y-1">
                    <div className="h-4 w-20 bg-gray-200 animate-pulse rounded" />
                    <div className="h-3 w-16 bg-gray-200 animate-pulse rounded" />
                  </div>
                  <div className="flex justify-end">
                    <div className="h-8 w-8 bg-gray-200 animate-pulse rounded-full" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : users.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-muted-foreground">{`No ${userStatus} users found`}</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="hover:bg-transparent">
                <TableHead className="font-semibold">Username</TableHead>
                <TableHead className="font-semibold">Email</TableHead>
                <TableHead className="font-semibold">Role</TableHead>
                <TableHead className="font-semibold">Status</TableHead>
                <TableHead className="font-semibold">Created</TableHead>
                <TableHead className="font-semibold">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map(user => (
                <TableRow key={user.id} className="hover:bg-muted/50">
                  <TableCell>
                    <div className="flex items-center">
                      {user.imageUrl ? (
                        <img
                          src={user.imageUrl}
                          alt={user.username}
                          className="object-cover mr-2 w-8 h-8 rounded-full border"
                        />
                      ) : (
                        <div className="mr-2 w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600">
                          {user.username?.charAt(0)?.toUpperCase() || "U"}
                        </div>
                      )}
                      <span className="font-medium">{user.username}</span>
                    </div>
                  </TableCell>
                  <TableCell>
                    <span className="text-sm">{user.emailAddress}</span>
                  </TableCell>
                  <TableCell>
                    <Badge variant="secondary" className="bg-blue-100 text-blue-800 hover:bg-blue-100">
                      {user.organizationRole?.name || "N/A"}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <Badge
                      variant={user.status === "ACTIVE" ? "default" : "secondary"}
                      className={
                        user.status === "ACTIVE"
                          ? "bg-green-100 text-green-800 hover:bg-green-100"
                          : user.status === "DISABLED"
                            ? "bg-red-100 text-red-800 hover:bg-red-100"
                            : "bg-gray-100 text-gray-800 hover:bg-gray-100"
                      }
                    >
                      {user.status}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <div className="text-sm">
                      <div className="font-medium">{formatDateTime(user.createdAt).date}</div>
                      <div className="text-xs text-muted-foreground">{formatDateTime(user.createdAt).time}</div>
                    </div>
                  </TableCell>
                  <TableCell>
                    {user.id !== currentUserId && (
                      <div className="flex items-center gap-1">
                        {user.status === "INACTIVE" && (
                          <TooltipProvider>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <Button
                                  variant="ghost"
                                  size="sm"
                                  className="h-8 w-8 p-0 text-blue-600 hover:text-blue-700 hover:bg-blue-50"
                                  disabled={resendingUserId === user.id}
                                  onClick={() => handleResendConfirmation(user)}
                                >
                                  {resendingUserId === user.id ? (
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                  ) : (
                                    <Mail className="h-4 w-4" />
                                  )}
                                </Button>
                              </TooltipTrigger>
                              <TooltipContent>
                                <p>Resend Invitation Email</p>
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        )}
                        <DropdownMenu>
                          <DropdownMenuTrigger asChild>
                            <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
                              <FaEllipsisH className="h-4 w-4" />
                            </Button>
                          </DropdownMenuTrigger>
                          <DropdownMenuContent align="end" className="w-52">
                            {user.status === "INACTIVE" && (
                              <>
                                <DropdownMenuItem
                                  onClick={() => handleResendConfirmation(user)}
                                  disabled={resendingUserId === user.id}
                                  className="text-blue-600 focus:text-blue-600 focus:bg-blue-50 cursor-pointer"
                                >
                                  {resendingUserId === user.id ? (
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                  ) : (
                                    <Mail className="mr-2 h-4 w-4" />
                                  )}
                                  <span>Resend Invite Email</span>
                                </DropdownMenuItem>
                                <DropdownMenuSeparator />
                              </>
                            )}
                            <DropdownMenuItem onClick={() => handleEditShow(user)}>
                              <Edit className="mr-2 h-4 w-4" />
                              <span>Edit</span>
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                            <DropdownMenuItem
                              className="text-red-600 focus:text-red-600 focus:bg-red-50"
                              onClick={() => {
                                setUserToDelete(user);
                                setDeleteShow(true);
                              }}
                            >
                              <Trash2 className="mr-2 h-4 w-4" />
                              <span>Delete</span>
                            </DropdownMenuItem>
                          </DropdownMenuContent>
                        </DropdownMenu>
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}

      {/* Pagination */}
      {Array.isArray(users) && users.length > 0 && pagination.totalCount > 0 && (
        <div className="flex justify-center mt-6">
          <Pagination
            className="pagination-bar"
            currentPage={pagination.page}
            totalCount={pagination.totalCount}
            pageSize={pagination.limit}
            siblingCount={1}
            onPageChange={page => handlePageChange(page)}
          />
        </div>
      )}

      {/* Invite Users Modal - Shadcn Dialog */}
      <Dialog open={show} onOpenChange={setShow}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Add New User</DialogTitle>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="username">Username</Label>
                <Input
                  id="username"
                  name="username"
                  value={inviteUserForm.username}
                  onChange={handleInviteUserInputChange}
                  placeholder="Enter username"
                  required
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="firstName">First Name</Label>
                <Input
                  id="firstName"
                  name="firstName"
                  value={inviteUserForm.firstName}
                  onChange={handleInviteUserInputChange}
                  placeholder="Enter first name"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="lastName">Last Name</Label>
                <Input
                  id="lastName"
                  name="lastName"
                  value={inviteUserForm.lastName}
                  onChange={handleInviteUserInputChange}
                  placeholder="Enter last name"
                  required
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="emailAddress">Email Address</Label>
                <Input
                  id="emailAddress"
                  name="emailAddress"
                  type="email"
                  value={inviteUserForm.emailAddress}
                  onChange={handleInviteUserInputChange}
                  placeholder="Enter email address"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="msisdn">Mobile (Optional)</Label>
                <Input
                  id="msisdn"
                  name="msisdn"
                  value={inviteUserForm.msisdn}
                  onChange={handleInviteUserInputChange}
                  placeholder="Enter mobile number"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="role">Role</Label>
                {organizationRolesLoading ? (
                  <div className="py-2 text-sm text-gray-500">Loading roles...</div>
                ) : (
                  <Select
                    name="role"
                    value={inviteUserForm.role}
                    onValueChange={value => handleInviteUserInputChange({ target: { name: "role", value } })}
                  >
                    <SelectTrigger className={isRoleNotSelected ? "border-red-500" : ""}>
                      <SelectValue placeholder="Select Role" />
                    </SelectTrigger>
                    <SelectContent>
                      {organizationRoles && organizationRoles.length > 0 ? (
                        organizationRoles.map(role => (
                          <SelectItem key={role.id} value={role.id}>
                            {role.name}
                          </SelectItem>
                        ))
                      ) : (
                        <SelectItem value="no-roles" disabled>
                          No roles available
                        </SelectItem>
                      )}
                    </SelectContent>
                  </Select>
                )}
                {isRoleNotSelected && <p className="text-sm text-red-500">Please select role</p>}
              </div>
            </div>

            {currentUserRole && currentUserRole !== "ROLE_HOST" && currentUserRole !== "ROLE_ADMINISTRATOR" && (
              <div className="space-y-2">
                <Label htmlFor="bundle">Type of Bundle</Label>
                <Select value={selectedBundle} onValueChange={setSelectedBundle}>
                  <SelectTrigger className={isBundleNotSelected ? "border-red-500" : ""}>
                    <SelectValue placeholder="Select Bundle" />
                  </SelectTrigger>
                  <SelectContent>
                    {bundles &&
                      bundles.map((bundle, index) => {
                        const bundleType = bundle.bundleType;
                        return (
                          <SelectItem key={index} value={bundleType.value}>
                            {bundleType.label}
                          </SelectItem>
                        );
                      })}
                  </SelectContent>
                </Select>
                {isBundleNotSelected && <p className="text-sm text-red-500">Please select bundle</p>}
              </div>
            )}
          </div>

          <div className="flex justify-end space-x-2 pt-4 border-t">
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            <Button onClick={inviteUser} disabled={isBookingLoading}>
              {isBookingLoading ? "Adding..." : "Add User"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Edit User Dialog */}
      <Dialog open={editShow} onOpenChange={setEditShow}>
        <DialogContent className="sm:max-w-[700px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit User</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            {/* Profile Picture */}
            <div className="space-y-2">
              <Label>Profile Picture</Label>
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0">
                  {editFormData.imageUrl ? (
                    <img src={editFormData.imageUrl} alt="Profile" className="w-full h-full object-cover" />
                  ) : (
                    <User className="w-8 h-8 text-gray-400" />
                  )}
                </div>
                <Input
                  type="file"
                  accept="image/*"
                  className="flex-1"
                  onChange={async e => {
                    const file = e.target.files?.[0];
                    if (file) {
                      try {
                        const response = await spaceManagementService.uploadMedia([file]);
                        if ((response.status === 200 || response.status === 201) && response.data?.length > 0) {
                          handleEditFormChange("imageUrl", response.data[0]);
                          toastUtils.success("Profile picture uploaded");
                        } else {
                          toastUtils.error("Failed to upload image");
                        }
                      } catch (error) {
                        logger.error("Error uploading profile picture:", error);
                        toastUtils.error("Failed to upload image");
                      }
                    }
                  }}
                />
              </div>
            </div>

            {/* Two Column Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Username (read-only) */}
              <div className="space-y-2">
                <Label htmlFor="edit-username">Username</Label>
                <Input
                  id="edit-username"
                  value={currentSelectedUser?.username || ""}
                  disabled
                  className="bg-gray-50 cursor-not-allowed"
                  placeholder="Username cannot be changed"
                />
              </div>

              {/* Email Address */}
              <div className="space-y-2">
                <Label htmlFor="edit-emailAddress">Email Address</Label>
                <Input
                  id="edit-emailAddress"
                  type="email"
                  value={editFormData.emailAddress}
                  onChange={e => handleEditFormChange("emailAddress", e.target.value)}
                  placeholder="Enter email address"
                />
              </div>

              {/* First Name */}
              <div className="space-y-2">
                <Label htmlFor="edit-firstName">First Name</Label>
                <Input
                  id="edit-firstName"
                  value={editFormData.firstName}
                  onChange={e => handleEditFormChange("firstName", e.target.value)}
                  placeholder="Enter first name"
                />
              </div>

              {/* Last Name */}
              <div className="space-y-2">
                <Label htmlFor="edit-lastName">Last Name</Label>
                <Input
                  id="edit-lastName"
                  value={editFormData.lastName}
                  onChange={e => handleEditFormChange("lastName", e.target.value)}
                  placeholder="Enter last name"
                />
              </div>

              {/* Phone Number */}
              <div className="space-y-2">
                <Label htmlFor="edit-msisdn">Phone Number</Label>
                <PhoneInput
                  value={editFormData.msisdn}
                  onChange={value => handleEditFormChange("msisdn", value)}
                />
              </div>

              {/* Organization Role */}
              <div className="space-y-2">
                <Label htmlFor="edit-role">Organization Role</Label>
                {organizationRolesLoading ? (
                  <div className="py-2 text-sm text-gray-500">Loading roles...</div>
                ) : (
                  <Select
                    value={editFormData.organizationRoleId}
                    onValueChange={value => handleEditFormChange("organizationRoleId", value)}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select a role" />
                    </SelectTrigger>
                    <SelectContent>
                      {organizationRoles.map(role => (
                        <SelectItem key={role.id} value={role.id}>
                          {role.name}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                )}
              </div>

              {/* User Status */}
              <div className="space-y-2">
                <Label htmlFor="edit-status">Status</Label>
                <Select value={editFormData.status} onValueChange={value => handleEditFormChange("status", value)}>
                  <SelectTrigger>
                    <SelectValue placeholder="Select status" />
                  </SelectTrigger>
                  <SelectContent>
                    {currentSelectedUser?.status === "ACTIVE" && <SelectItem value="DISABLED">Disabled</SelectItem>}
                    {currentSelectedUser?.status === "INACTIVE" && (
                      <>
                        <SelectItem value="INACTIVE">Inactive (Pending Confirmation)</SelectItem>
                        <SelectItem value="ACTIVE">Active</SelectItem>
                      </>
                    )}
                    {currentSelectedUser?.status === "DISABLED" && <SelectItem value="ACTIVE">Active</SelectItem>}
                  </SelectContent>
                </Select>
                {currentSelectedUser?.status === "INACTIVE" && (
                  <div className="pt-2">
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      disabled={resendingUserId === currentSelectedUser.id}
                      onClick={() => handleResendConfirmation(currentSelectedUser)}
                      className="w-full text-blue-600 border-blue-200 hover:bg-blue-50 hover:text-blue-700 flex items-center justify-center gap-2"
                    >
                      {resendingUserId === currentSelectedUser.id ? (
                        <Loader2 className="h-4 w-4 animate-spin" />
                      ) : (
                        <Mail className="h-4 w-4" />
                      )}
                      <span>Resend Invitation Email</span>
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3">
            <Button variant="outline" onClick={() => setEditShow(false)}>
              Cancel
            </Button>
            <Button onClick={updateUserProfile}>Update User</Button>
          </div>
        </DialogContent>
      </Dialog>

      <InformationModal
        title="Confirm Enable"
        isOpen={enableModal}
        isClose={enableUserClose}
        onSubmit={confirmEnableUser}
        acceptButton="Enable"
        declineButton="Cancel"
      >
        <div className="text-lg">Are you sure you want to enable this User?</div>
      </InformationModal>

      <InformationModal
        title="Confirm Disable"
        isOpen={disableModal}
        isClose={disableUserClose}
        onSubmit={confirmDisableUser}
        acceptButton="Disable"
        declineButton="Cancel"
      >
        <div className="text-lg">Are you sure you want to disable this User?</div>
      </InformationModal>

      {/* <ResetPasswordModal
        title="Confirm Reset"
        isOpen={resetPasswordModal}
        isClose={closeResetPasswordModal}
        onSubmit={confirmResetPassword}
        acceptButton="Reset Password"
        declineButton="Cancel"
        className="reset-password"
      >
        <div className="text-lg text-primary">
          Confirm reset password for this user
        </div>
      </ResetPasswordModal> */}

      <InformationModal
        title="Confirm Deletion"
        isOpen={deleteshow}
        isClose={handleDeleteClose}
        onSubmit={confirmDeleteOpen}
        acceptButton="Delete"
        declineButton="Cancel"
      >
        <div className="text-lg">Are you sure you want to delete this User?</div>
      </InformationModal>

      <InformationModal
        title="Confirm Deletion"
        isOpen={showPendingDeleteModal}
        isClose={handlePendingDeleteClose}
        // onSubmit={confirmPendingDeleteUser}
        acceptButton="Delete"
        declineButton="Cancel"
      >
        <div className="text-lg">Are you sure you want to delete this User?</div>
      </InformationModal>
    </div>
  );
};

export default UserManagement;
